import React from 'react';
import { Text, View } from '@react-pdf/renderer';

const StatSizes = {
  'sm': 14,
  'md': 24,
  'lg': 32,
};
const ValuePropPrintSummary = ({
  stat,
  statSize = 'md',
  statWidth = 57,
  description,
  descriptionWidth = 180,
  borderColor = 'black',
}): JSX.Element => {
  return (
    <View style={{
      height: 60,
      borderTop: `1px solid ${borderColor}`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }}>
      <View style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}>
          <Text style={{
            fontFamily: 'Helvetica-Bold',
            fontSize: StatSizes[statSize],
            lineHeight: 1,
            width: statWidth,
            textAlign: 'right',
          }}>{stat}</Text>
          <Text style={{
            marginLeft: 12,
            fontSize: 9,
            lineHeight: 1.33,
            width: descriptionWidth - statWidth,
          }}>{description}</Text>
      </View>
    </View>
  );
};

export default ValuePropPrintSummary;
